import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotPassword,
  FetchCompanyDetails,
  fetchTranslationData,
} from "../../redux/actions/action";
import "../../assets/styles/local/ResetPassword.css";
import eyeIcon from "../../../src/assets/icons/eye.svg";
import noteyeIcon from "../../../src/assets/icons/Notshow.svg";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Resetpassword = () => {
  const [password, setPassword] = useState("");
  const [conformPassword, setConformPassword] = useState("");
  const [error, setError] = useState(false);
  const [errormissmatch, setErrormissmatch] = useState(false);
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const [fetchTransList, setFetchTransList] = useState({});
  const t = (key) => fetchTransList?.[key] || "";
  const history = useHistory();
  const userid = useParams();
  const suerId = userid.userid;
  const dispatch = useDispatch();
  const passwordToken = new URLSearchParams(window.location.search).get(
    "token",
  );
  const forgotPasswordData = useSelector((state) => state.user.forgotPassword);
  const [companyId, setCompanyId] = useState(
    "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  );
  const instadagmoduleid = window.localStorage.getItem("companyid");
  const [errmsgForgot, seterrmsgForgot] = useState("");

  useEffect(() => {
    dispatch(FetchCompanyDetails(localStorage.getItem("workspaceName")));
  }, []);

  React.useEffect(() => {
    if (FetchCompanyDetails1 != null && FetchCompanyDetails1.status === true) {
      fetchScreenTranslations("Login", {
        language: "English",
        companyid: FetchCompanyDetails1?.data[0]?.companyid,
      }).then((res) => {
        setFetchTransList(res);
      });
    }
  }, [FetchCompanyDetails1]);

  const initialRender = React.useRef(true);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (forgotPasswordData != null) {
        if (forgotPasswordData.status == true) {
          setPassword("");
          setConformPassword("");
          seterrmsgForgot("");
          handleGeneralNotification({ notificationType: "RESET_PASSWORD" });
        } else {
          seterrmsgForgot(forgotPasswordData?.message);
        }
      }
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1?.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1?.data);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [forgotPasswordData, FetchCompanyDetails1]);

  const handleSubmit = (e) => {
    if (password == "" || conformPassword == "") {
      e.preventDefault();
      setError(true);
      setErrormissmatch(false);
    } else if (password !== conformPassword) {
      e.preventDefault();
      setErrormissmatch(true);
    } else {
      dispatch(
        forgotPassword(suerId, password, conformPassword, passwordToken),
      );

      setIsDisable(true);
      setTimeout(() => {
        setIsDisable(false);
      }, 3000);
      // history.push("/");
      e.preventDefault();
    }
  };

  return (
    <>
      <section>
        <div
          className="resetpassword-main-container"
          style={{ "--text-color": `${FetchCompanyThemRes[0]?.textcolor}` }}
        >
          <Row className="w-100">
            <Col xs={12} sm={12} md={12} xl={7}>
              <div className="d-flex align-items-center justify-content-center">
                <img
                  className="company-logo"
                  src={FetchCompanyThemRes[0]?.companylogo}
                  alt="Company Logo"
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} xl={5}>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <label className="text-welcome">{t("Reset password")}</label>
              </div>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <div className="password-form">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid #A5A5A5",
                      }}
                    >
                      <input
                        id="userinput2"
                        value={password}
                        onChange={(e) => {
                          setError(false);
                          setPassword(e.target.value);
                        }}
                        className="input-style2 input-width "
                        type={showPassword ? "text" : "password"}
                        placeholder=". . . . . ."
                        style={{ width: "100%" }}
                      />
                      {showPassword ? (
                        <img
                          src={eyeIcon}
                          style={{
                            color: "gray",
                            height: "14.5px",
                            width: "20.66px",
                          }}
                          className="bi-paperclip mt-1"
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      ) : (
                        <img
                          src={noteyeIcon}
                          style={{
                            color: "gray",
                            height: "16.5px",
                            width: "20.66px",
                          }}
                          className="bi-paperclip mt-1"
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      )}
                    </div>
                    <div className="text-start">
                      {!password && error && (
                        <div className="warning">
                          <i class="bi bi-exclamation-circle me-1"></i>
                          Please fill in this field
                        </div>
                      )}
                      {errmsgForgot && (
                        <div className="warning">
                          <i class="bi bi-exclamation-circle me-1"></i>
                          {errmsgForgot}
                        </div>
                      )}
                      <label
                        className="formleble12"
                        for="exampleFormControlInput1"
                        style={{
                          color: `${
                            FetchCompanyThemRes[0]?.textcolor
                              ? FetchCompanyThemRes[0]?.label
                              : "#707070"
                          }`,
                        }}
                      >
                        {t("New password")}
                      </label>
                    </div>
                  </div>
                  <div className="second-input">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid #A5A5A5",
                      }}
                    >
                      <input
                        id="userinput1"
                        value={conformPassword}
                        onChange={(e) => {
                          setError(false);
                          setConformPassword(e.target.value);
                        }}
                        className="input-style2 input-width "
                        type={showPassword2 ? "text" : "password"}
                        placeholder=". . . . . ."
                        style={{ width: "100%" }}
                      />
                      {showPassword2 ? (
                        <img
                          src={eyeIcon}
                          style={{
                            color: "gray",
                            height: "14.5px",
                            width: "20.66px",
                          }}
                          className="bi-paperclip mt-1"
                          onClick={() => setShowPassword2(!showPassword2)}
                        />
                      ) : (
                        <img
                          src={noteyeIcon}
                          style={{
                            color: "gray",
                            height: "16.5px",
                            width: "20.66px",
                          }}
                          className="bi-paperclip mt-1"
                          onClick={() => setShowPassword2(!showPassword2)}
                        />
                      )}
                    </div>
                    <div className="text-start">
                      {!conformPassword && !password && error && (
                        <div className="warning">
                          <i class="bi bi-exclamation-circle me-1"></i>
                          Please fill in this field
                        </div>
                      )}
                      {password && !conformPassword && error && (
                        <div className="warning">
                          <i class="bi bi-exclamation-circle me-1"></i>
                          Please confirm your Password
                        </div>
                      )}
                      {errormissmatch && (
                        <div className="warning">
                          <i className="bi bi-exclamation-circle me-1"></i>
                          Your password and confirmation password do not match
                        </div>
                      )}
                      <label
                        className="formleble12"
                        for="exampleFormControlInput1"
                        style={{
                          color: `${
                            FetchCompanyThemRes[0]?.textcolor
                              ? FetchCompanyThemRes[0]?.label
                              : "#707070"
                          }`,
                        }}
                      >
                        {t("Confirm new password")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <div className="button-container text-center text-lg-start">
                  <button
                    className="app-btn-primary"
                    onClick={handleSubmit}
                    disabled={isDisable}
                  >
                    {t("Recover")}
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default Resetpassword;
